// @ts-nocheck
export type UnitDimension = 'length' | 'area' | 'volume' | 'weight' | 'time' | 'pressure';

export interface UnitDefinition {
  id: string;
  dimension: UnitDimension;
  factorToBase: number;
  displayNames?: Readonly<Record<string, string>>;
  aliases: Readonly<Record<string, readonly string[]>>;
}

export interface MaterialDefinition {
  id: string;
  gramsPerUsCup: number;
  gramsPerUsTbsp: number;
  aliases: Readonly<Record<string, readonly string[]>>;
}

export interface UnitsDataAsset {
  version: number;
  baseUnits: Readonly<Record<UnitDimension, string>>;
  rounding: Readonly<Record<UnitDimension, { decimals: number }>>;
  units: readonly UnitDefinition[];
}

export interface MaterialsDataAsset {
  version: number;
  materials: readonly MaterialDefinition[];
}

export interface UnitsCatalog {
  unitsById: ReadonlyMap<string, UnitDefinition>;
  materialsById: ReadonlyMap<string, MaterialDefinition>;
  aliasIndex: ReadonlyMap<string, string>;
  materialAliasIndex: ReadonlyMap<string, string>;
  baseUnits: Readonly<Record<UnitDimension, string>>;
  rounding: Readonly<Record<UnitDimension, { decimals: number }>>;
}

export interface ConvertQuantityOptions {
  value: number;
  fromUnit: string;
  toUnit: string;
  material?: string;
  locale?: string;
}

export interface ConvertQuantityResult {
  ok: true;
  value: number;
  unit: string;
  converted: boolean;
}

export interface ListUnitsEntry {
  id: string;
  dimension: UnitDimension;
  displayName: string;
  aliases: readonly string[];
}

export interface ListUnitsOptions {
  dimension?: UnitDimension;
  locale?: string;
}

export const UNIT_DIMENSIONS: readonly UnitDimension[] = [
  'length',
  'area',
  'volume',
  'weight',
  'time',
  'pressure',
] as const;

export function isUnitDimension(value: string): value is UnitDimension {
  return (UNIT_DIMENSIONS as readonly string[]).includes(value);
}
